import ReactGA from 'react-ga4';
import { apiClient } from 'services/api/apiClient';
import {
  GOOGLE_ANALYTICS_TRACKIND_ID,
  PLATFORM_LEGAL_CORPORATION_ID,
  PLATFORM_LEGAL_CORPORATION_LABEL,
} from 'services/api/constants';
import { logger } from 'services/logs/logger';

import { AnalyticsInterface, UserDetails } from './AnalyticsInterface';
import { GOOGLE_ANALYTICS_CATEGORIES } from './config';

type UserProperties = {
  legal_corporation: string;
  user_role: string | undefined;
  user_identifier: string | number | undefined;
  legal_corporation_id: string;
  user_type: string;
};

export class GoogleAnalytics implements AnalyticsInterface {
  private userProperties: UserProperties | undefined;

  async init(): Promise<void> {
    ReactGA.initialize([
      {
        trackingId: GOOGLE_ANALYTICS_TRACKIND_ID,
      },
    ]);
  }

  setUserConfig(userDetails: UserDetails | null): void {
    if (userDetails) {
      const userEmail = userDetails?.userId ?? '';
      const userType =
        userEmail.match(/@colas/gi) ||
        userEmail.match(/@groupecolas/gi) ||
        userEmail.match(/@barrettpaving/gi) ||
        userEmail.match(/@barrettindustries/gi) ||
        userEmail.match(/@strawserconstruction/gi) ||
        userEmail.match(/@upstonematerials/gi) ||
        userEmail.match(/@sully-miller/gi) ||
        userEmail.match(/@millergroup/gi) ||
        userEmail.match(/@reevescc/gi) ||
        userEmail.match(/@deltacos/gi)
          ? 'Internal'
          : 'External';
      this.userProperties = {
        legal_corporation: PLATFORM_LEGAL_CORPORATION_LABEL,
        user_role: userDetails?.role?.label,
        user_identifier: userDetails?.userMetadata?.id,
        legal_corporation_id: PLATFORM_LEGAL_CORPORATION_ID,
        user_type: userType,
      };
      ReactGA.gtag('set', 'user_properties', this.userProperties);
    }
  }

  event(action: string, label: string, data: string): void {
    const gaDisabled =
      (window as unknown as Record<string, boolean>)[
        `ga-disable-${GOOGLE_ANALYTICS_TRACKIND_ID}`
      ] === true;
    // console.log('GA event dispatched', {
    //   action,
    //   label,
    //   category: data,
    //   gaDisabled,
    //   userProperties: this.userProperties,
    // });
    try {
      ReactGA.event({
        category: data,
        action: action,
        label: label,
        transport: 'beacon',
      });
    } catch (error) {
      console.log('GA event dispatch failed', { action, label, error });
    }
    if (GOOGLE_ANALYTICS_CATEGORIES.PAYMENT === data) {
      apiClient
        .request('POST', '/log/frontend-event', {
          category: data,
          action,
          label,
          gaDisabled,
          userProperties: this.userProperties ?? null,
        })
        .catch((error) => {
          logger.logWarn('Failed to forward frontend event to backend', error);
        });
    }
  }
}
